<mat-card
  [ngClass]="{
    'card-container': true,
    'warn-color': connection?.status === connectionStatus.DISCONNECTED,
  }"
  *ngIf="integration"
  (click)="redirect()"
>
  <mat-card-header>
    <div class="integration-row">
      <div class="logo-container">
        <img class="logo" mat-card-avatar [src]="integration.logo" alt="avatar" (error)="handleImageError($event)" />
      </div>
      <mat-card-title>{{ integration.displayName }}</mat-card-title>
      <div class="icon-status">
        <mat-icon
          *ngIf="
            connection?.status === connectionStatus.DISCONNECTED || connection?.status === connectionStatus.PRECONNECTED
          "
          [ngClass]="{
            'icon-warn-color': connection?.status === connectionStatus.DISCONNECTED,
            'icon-info-color': connection?.status === connectionStatus.PRECONNECTED,
          }"
        >
          {{ connection?.status === connectionStatus.DISCONNECTED ? 'warning' : 'info' }}
        </mat-icon>
        <mat-icon *ngIf="connection?.status === connectionStatus.CONNECTED" class="icon-color"> check_circle </mat-icon>
      </div>
    </div>
  </mat-card-header>
  <mat-card-content *ngIf="tab === userAction.BROWSE">
    {{ integration.description }}
  </mat-card-content>
  <mat-card-content *ngIf="tab === userAction.MANAGE">
    <div class="profile-details-container">
      <glxy-avatar
        *ngIf="connection?.label || user"
        [src]="getProfileImageUrl(connection) || user?.profileImageUrl"
        [name]="connection?.label || user?.firstName + ' ' + user?.lastName"
      >
      </glxy-avatar>
      <ng-container *ngIf="connection?.status === connectionStatus.PRECONNECTED && user; else connectedCardContent">
        <span>{{ user?.firstName + ' ' + user?.lastName }}</span>
      </ng-container>

      <ng-template #connectedCardContent>
        <span>
          {{
            connection?.label ||
              (user
                ? user?.firstName + ' ' + user?.lastName
                : connection?.statusLastUpdated
                  ? ('INTEGRATION_CARD.CONNECTED_DATE' | translate: { date: (getStatusLastUpdatedDate() | glxyDate) })
                  : '')
          }}
        </span>
      </ng-template>
    </div>
  </mat-card-content>
</mat-card>
